export const STYLES = {
  WRAPPER: 'border-[1px] border-bw03 rounded-[8px] hover:shadow-light hover:border-action03 fadeIn',
  WRAPPER_DISABLED: 'border-[1px] border-bw03 rounded-[8px] fadeIn cursor-default',
  FLEX_CENTER: 'flex items-center justify-between gap-[10px]',
  TITLE: 'font-metricR text-[#20242E] text-[16px] mr-[4px]',
  SUB_TITLE: 'font-metricR text-bw07 text-[14px]',
  BTN_CONTAINER: 'w-full h-full p-[16px]',
  BTN_CONTAINER_DISABLED: 'w-full h-full p-[16px] opacity-50 !cursor-default',
};
